import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.title',
		defaultMessage: 'Change workflow editor preference',
		description: 'Heading for the default workflow modal.',
	},
	instruction: {
		id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.instruction',
		defaultMessage: 'Preferred workflow editor',
		description: 'Instruction text to choose default editor.',
	},
	workflowEditorNewLabel: {
		id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.workflow-editor-new-label',
		defaultMessage: 'Workflow editor',
		description: 'Label of workflow editor new option.',
	},
	workflowEditorOldLabel: {
		id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.workflow-editor-old-label',
		defaultMessage: 'Workflow editor',
		description: 'Label of workflow editor old option.',
	},
	workflowEditorNewDescription: {
		id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.workflow-editor-new-description',
		defaultMessage:
			'Simplified setup and changes, all in one screen. Easier updates. Bonus <strong>Workflow builder</strong> agent support for AI enabled sites.',
		description: 'Description of workflow editor new option.',
	},
	workflowEditorOldDescription: {
		id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.workflow-editor-old-description',
		defaultMessage:
			'Keep using the old editor until it’s no longer available from  early 2026. Any unsaved drafts in the old editor will be lost after this time.',
		description: 'Description of workflow editor old option.',
	},
	workflowEditorNewLozenge: {
		id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.workflow-editor-new-lozenge',
		defaultMessage: 'New',
		description: 'Label for workflow editor new icon.',
	},
	workflowEditorOldLozenge: {
		id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.workflow-editor-old-lozenge',
		defaultMessage: 'Old',
		description: 'Label for workflow editor old icon.',
	},
	cancelButton: {
		id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.cancel-button',
		defaultMessage: 'Cancel',
		description: 'Label for back button.',
	},
	confirmButton: {
		id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.confirm-button',
		defaultMessage: 'Confirm',
		description: 'Label for confirm button.',
	},
	updateButton: {
		id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.update-button',
		defaultMessage: 'Update',
		description: 'Label for update button.',
	},
	warning: {
		id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.warning-label',
		defaultMessage: 'Warning',
		description: 'Label for the warning icon in the workflow editor preference dialog.',
	},
	draftUnpublishedWarning: {
		id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.draft-unpublished-warning',
		defaultMessage:
			'Publish your draft workflow before continuing so that your edits will be visible in the new workflow editor.',
		description:
			'A warning message informing users to publish their draft their workflow before switching workflow editors as otherwise the changes will not be reflected in the new editor.',
	},
	dirtyLossWarning: {
		id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.dirty-loss-warning',
		defaultMessage:
			'You’ve made changes to {workflowName}. To save those changes select {cancel}, then {update} workflow before continuing.',
		description:
			'A warning message informing users to save any changes to their workflow before switching workflow editors as they will otherwise be lost.',
	},
});
